// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"264b03f2","852":"d550abab"}[chunkId] + ".chunk.js";
};